"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var react_1 = tslib_1.__importDefault(require("react"));
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
var core_1 = require("@material-ui/core");
var core_2 = require("@jsonforms/core");
var react_2 = require("@jsonforms/react");
var layout_1 = require("../util/layout");
exports.materialCategorizationStepperTester = core_2.rankWith(2, core_2.and(core_2.uiTypeIs('Categorization'), core_2.categorizationHasCategory, core_2.optionIs('variant', 'stepper')));
var MaterialCategorizationStepperLayoutRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(MaterialCategorizationStepperLayoutRenderer, _super);
    function MaterialCategorizationStepperLayoutRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeCategory: 0
        };
        _this.handleStep = function (step) {
            _this.setState({ activeCategory: step });
        };
        return _this;
    }
    MaterialCategorizationStepperLayoutRenderer.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, path = _a.path, renderers = _a.renderers, schema = _a.schema, uischema = _a.uischema, visible = _a.visible, cells = _a.cells, config = _a.config, ajv = _a.ajv;
        var categorization = uischema;
        var activeCategory = this.state.activeCategory;
        var appliedUiSchemaOptions = merge_1.default({}, config, uischema.options);
        var buttonWrapperStyle = {
            textAlign: 'right',
            width: '100%',
            margin: '1em auto'
        };
        var buttonNextStyle = {
            float: 'right'
        };
        var buttonStyle = {
            marginRight: '1em'
        };
        var childProps = {
            elements: categorization.elements[activeCategory].elements,
            schema: schema,
            path: path,
            direction: 'column',
            visible: visible,
            renderers: renderers,
            cells: cells
        };
        var categories = categorization.elements.filter(function (category) {
            return core_2.isVisible(category, data, undefined, ajv);
        });
        return (react_1.default.createElement(core_1.Hidden, { xsUp: !visible },
            react_1.default.createElement(core_1.Stepper, { activeStep: activeCategory, nonLinear: true }, categories.map(function (e, idx) { return (react_1.default.createElement(core_1.Step, { key: e.label },
                react_1.default.createElement(core_1.StepButton, { onClick: function () { return _this.handleStep(idx); } }, e.label))); })),
            react_1.default.createElement("div", null,
                react_1.default.createElement(layout_1.MaterialLayoutRenderer, tslib_1.__assign({}, childProps))),
            !!appliedUiSchemaOptions.showNavButtons ? (react_1.default.createElement("div", { style: buttonWrapperStyle },
                react_1.default.createElement(core_1.Button, { style: buttonNextStyle, variant: "contained", color: "primary", disabled: activeCategory >= categories.length - 1, onClick: function () { return _this.handleStep(activeCategory + 1); } }, "Next"),
                react_1.default.createElement(core_1.Button, { style: buttonStyle, color: "secondary", variant: "contained", disabled: activeCategory <= 0, onClick: function () { return _this.handleStep(activeCategory - 1); } }, "Previous"))) : (react_1.default.createElement(react_1.default.Fragment, null))));
    };
    return MaterialCategorizationStepperLayoutRenderer;
}(react_2.RendererComponent));
exports.MaterialCategorizationStepperLayoutRenderer = MaterialCategorizationStepperLayoutRenderer;
exports.default = react_2.withJsonFormsLayoutProps(layout_1.withAjvProps(MaterialCategorizationStepperLayoutRenderer));
//# sourceMappingURL=MaterialCategorizationStepperLayout.js.map